export default "__VITE_ASSET__CA2a$mVS__"